import { render, staticRenderFns } from "./ReportsDialog.vue?vue&type=template&id=0c4ee27b"
import script from "./ReportsDialog.vue?vue&type=script&lang=js"
export * from "./ReportsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports